import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var HeartHexagon = function HeartHexagon(props) {
  return /*#__PURE__*/_jsxs("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props, {
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#fff",
      fillOpacity: 0.01,
      d: "M11.223 2.4316c.2836-.1575.4254-.2363.5755-.2672.133-.0273.27-.0273.403 0 .1501.031.2919.1097.5755.2672l7.4 4.1112c.2996.1664.4493.2496.5584.3679a1 1 0 0 1 .2141.364c.0505.1527.0505.324.0505.6667v8.1171c0 .3427 0 .514-.0505.6668a.9998.9998 0 0 1-.2141.3639c-.1091.1184-.2588.2016-.5584.368l-7.4 4.1111c-.2836.1575-.4254.2363-.5755.2672-.133.0273-.27.0273-.403 0-.1501-.0309-.2919-.1097-.5755-.2672l-7.4-4.1111c-.2995-.1664-.4493-.2496-.5584-.368a.9999.9999 0 0 1-.2141-.3639C3 16.5725 3 16.4012 3 16.0585v-8.117c0-.3427 0-.514.0505-.6669a1.0002 1.0002 0 0 1 .2141-.3639c.109-.1183.2588-.2015.5584-.368l7.4-4.111Z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      fillOpacity: 0.01,
      fillRule: "evenodd",
      d: "M11.9966 9.0679c-.9997-1.1687-2.6667-1.4831-3.9193-.413-1.2525 1.0702-1.4288 2.8596-.4452 4.1253.63.8107 2.2435 2.314 3.3221 3.2901.3585.3244.5377.4866.7524.5516.1845.056.3954.056.58 0 .2146-.065.3939-.2272.7523-.5516 1.0787-.9761 2.6921-2.4794 3.3222-3.2901.9836-1.2657.8288-3.0663-.4453-4.1252-1.2741-1.059-2.9195-.7558-3.9192.4129Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M11.223 2.4316c.2836-.1575.4254-.2363.5755-.2672.133-.0273.27-.0273.403 0 .1501.031.2919.1097.5755.2672l7.4 4.1112c.2996.1664.4493.2496.5584.3679a1 1 0 0 1 .2141.364c.0505.1527.0505.324.0505.6667v8.1171c0 .3427 0 .514-.0505.6668a.9998.9998 0 0 1-.2141.3639c-.1091.1184-.2588.2016-.5584.368l-7.4 4.1111c-.2836.1575-.4254.2363-.5755.2672-.133.0273-.27.0273-.403 0-.1501-.0309-.2919-.1097-.5755-.2672l-7.4-4.1111c-.2995-.1664-.4493-.2496-.5584-.368a.9999.9999 0 0 1-.2141-.3639C3 16.5725 3 16.4012 3 16.0585v-8.117c0-.3427 0-.514.0505-.6669a1.0002 1.0002 0 0 1 .2141-.3639c.109-.1183.2588-.2015.5584-.368l7.4-4.111Z"
    }), /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M11.9966 9.0679c-.9997-1.1687-2.6667-1.4831-3.9193-.413-1.2525 1.0702-1.4288 2.8596-.4452 4.1253.63.8107 2.2435 2.314 3.3221 3.2901.3585.3244.5377.4866.7524.5516.1845.056.3954.056.58 0 .2146-.065.3939-.2272.7523-.5516 1.0787-.9761 2.6921-2.4794 3.3222-3.2901.9836-1.2657.8288-3.0663-.4453-4.1252-1.2741-1.059-2.9195-.7558-3.9192.4129Z",
      clipRule: "evenodd"
    })]
  }));
};
export default HeartHexagon;